import type { ReactNode } from "react";

import { tv } from "tailwind-variants";

export const panelGroupVariants = tv({
	base: "relative flex h-full w-full overflow-hidden",
});

type PanelGroupProps = {
	readonly children: ReactNode;
	readonly className?: string;
};

export function PanelGroup({ children, className }: PanelGroupProps) {
	return (
		<div data-panel-group className={panelGroupVariants({ className })}>
			{children}
		</div>
	);
}
